import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import React, { useEffect } from "react";
import eyeUnderline from "assets/images/ct/eye-underline.png";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";

const Double6 = ({
  TopIcon,buzzer_sound,default_audio_effect,
  boldHeading = "",
  smallHeading = "",
  text1 = "",
  text2 = "",
  buttonText = "",
  buttonPress = () => {},
  diceData,
  move12Text1 = "",
  move12Text2 = "",
  move12ButtonText = "",
  diceSpecial6Text1 = "",
  diceSpecial6Text2 = "",
  diceSpecial6ButtonText = "",
  special6buttonPress = () => {},
  move12buttonPress = () => {}
}) => {
  const diceSpecial = diceData?.dice_special || null;
  const text1Data = text1.split(".");
  const text2Data = text2.split(",");
  const diceSpecial6Text1Data = diceSpecial6Text1.split("@");
  useEffect(() => {
    if (  !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, default_audio_effect]);

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="double-dice-wrapper"
    >
      <div className="double-dice">
        <motion.img
          variants={fadeVariants}
          src={TopIcon}
          className="img-fluid image"
          alt="grayEye"
        />
        <motion.h2 variants={fadeVariants} className="heading dice-six">
          {boldHeading}
        </motion.h2>
        <motion.h2 variants={fadeVariants} className="small-heading">
          {smallHeading}
        </motion.h2>
        <motion.img
          variants={fadeVariants}
          src={eyeUnderline}
          className="img-fluid line"
          alt=""
        />

        {diceSpecial === null ? (
          <>
            <motion.p variants={fadeVariants} className="desc">
              {text1Data[0]} <span>{text1Data[1]} </span>
            </motion.p>
            <motion.p variants={fadeVariants} className="desc">
              {text2Data[0]} <span>{text2Data[1]} </span>
            </motion.p>
            <motion.div
              variants={staticBounceVariants}
              style={{ width: "91%" }}
            >
              <button
                className="ct-btn-red roll-btn w-100"
                onClick={buttonPress}
              >
                {buttonText}
              </button>
            </motion.div>
          </>
        ) : diceSpecial === 6 ? (
          <>
            <motion.p variants={fadeVariants} className="desc">
              {diceSpecial6Text1Data[0]}
              <span>{diceSpecial6Text1Data[1]} </span>
              {diceSpecial6Text1Data[2]}
              <span>{diceSpecial6Text1Data[3]} </span>
              {diceSpecial6Text1Data[4]}
            </motion.p>
            <motion.p variants={fadeVariants} className="desc">
              <span>{diceSpecial6Text2} </span>
            </motion.p>
            <motion.div variants={staticBounceVariants} className="text-right">
              <button
                onClick={special6buttonPress}
                className="ct-btn-green px-5 confirm-btn"
                style={{
                  width: "auto",
                  padding: "8px 18px 10px 18px",
                  fontSize: "16px"
                }}
              >
                {diceSpecial6ButtonText}
              </button>
            </motion.div>
          </>
        ) : (
          <>
            <motion.p variants={fadeVariants} className="desc">
              {move12Text1}
            </motion.p>
            <motion.p variants={fadeVariants} className="desc">
              {move12Text2}
            </motion.p>
            <motion.div
              variants={staticBounceVariants}
              style={{ width: "91%" }}
            >
              <button
                className="ct-btn-green roll-btn w-100"
                onClick={move12buttonPress}
              >
                {move12ButtonText}
              </button>
            </motion.div>
          </>
        )}
      </div>
    </motion.div>
  );
};

export default Double6;
